import { displayTime } from '../utils';

function formatContactsList(trads, contacts) {
  if (!contacts || contacts.length === 0) return '';
  const names = contacts
    .map((ec) => ec.contact?.name || ec.name || '')
    .filter(Boolean);
  if (names.length === 0) return '';
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]}, ${names[1]}`;
  if (names.length === 3)
    return `${names[0]}, ${names[1]} ${trads.and} ${names[2]}`;
  return `${names[0]}, ${names[1]}, ${names[2]} +${names.length - 3}`;
}

export default function Event({ event, trads, lang, demoMode, onClick }) {
  const time = event.times?.[0] ?? 0;
  const preview =
    event.content?.length > 50
      ? event.content.slice(0, 50) + '...'
      : event.content;

  const contactsList = formatContactsList(trads, event.eventContacts);

  return (
    <div
      onClick={() => onClick?.(event)}
      data-testid="event-card"
      data-umami-event={demoMode ? 'click demo event' : 'click event'}
      className={`bg-amber-50 border border-amber-100 rounded-lg p-2 shadow-sm hover:bg-amber-100 cursor-pointer transition-colors`}
    >
      <div className="text-amber-950 font-semibold text-sm truncate">
        {event.name}
      </div>
      <div className="text-amber-750 text-xs mt-1 line-clamp-2">{preview}</div>
      <div className="text-amber-950 text-lg font-medium mt-1">
        {displayTime(time, lang)}
      </div>
      {contactsList && (
        <div className="text-amber-950 font-semibold text-sm truncate">
          {contactsList}
        </div>
      )}
    </div>
  );
}
